import React from 'react';

/**
 * PiStopBigStroke icon from the stroke style in media category.
 */
interface PiStopBigStrokeProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiStopBigStroke({
	size = 24,
	color,
	className,
	ariaLabel = 'stop-big icon',
	...props
}: PiStopBigStrokeProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M5 9.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C7.28 5 8.12 5 9.8 5h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 7.28 19 8.12 19 9.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C16.72 19 15.88 19 14.2 19H9.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 16.72 5 15.88 5 14.2z"
				fill="none"
			/>
		</svg>
	);
}
